export default "__VITE_ASSET__zRwqSQTT__"